import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']
type CallRoomPayload = IConversationTypeInterfacesMap[ConversationType.CallRoom]['conversationTypePayload']

export function useCallRoomConversationTypeStrategy() {
  const getConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as CallRoomPayload).callRoomId
  }

  const getRelayConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as CallRoomPayload).callRoomId
  }

  return {
    getConversationKey,
    getRelayConversationKey,
  }
}
